<div class="notification-bell" (click)="openNotifications()">
  <img class="bell" src="/assets/buttons/notification-bell.svg" width="20" height="22" alt="notifications" />
  <app-badge *ngIf="value" [isRed]="true" [value]="value"></app-badge>
</div>
